function scrollToPlans() {
    setTimeout(() => {
        document.getElementById('subscription-start-block')?.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }, 100);
}

export {
    scrollToPlans
};
